module.exports = __webpack_public_path__ + "static/media/arrow-head-black.7989d74f.svg";